import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import TopNav from '../containers/navs/Topnav';
import Sidebar from '../containers/navs/Sidebar';
import { AxiosAPI, getUserID, getGroupID } from '../helpers/AxiosAPI';
import { gAPI_Users_By_Id, gAPI_Property_List } from '../constants/APIs';
import { changeUser, checkPin } from '../redux/actions';
class AppLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      role: 'Admin',
      renderNav: false,
      propertyList: [],
      propertyId: '',
      userData: undefined,
    };
  }

  componentDidMount() {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    })
      .then((res) => {
        this.props.changeUser(res.data.email);
        this.setState({ userData: res.data });
        if(res.data.hasPin !== undefined){
          this.props.checkPin(res.data.hasPin);
        }else{
          this.props.checkPin(res.data.hasPin);
        }
      
        res.data?.roles &&  res.data.roles.forEach((r) => {
          if (r === 'User') {
            this.setState({ role: 'User' });
          }
          if (r === 'View' && res.data.roles.filter((f)=>f ==='Admin').length === 0) {
            this.setState({ role: 'View' });
          }
        });

        AxiosAPI({
          method: 'get',
          url: `${gAPI_Property_List}?group_id=${getGroupID()}`,
        })
          .then((pres) => {
            let property_id = this.props.propertyId;

            //console.log('property_id', property_id);
            // if (property_id === '-1') {
            //   property_id = ''
            // }
            if (
              res.data.properties.length > 0 &&
              res.data.properties[0] === '-1'
            ) {
              const hotel = pres.data.find((elem) => {
                return elem.id === property_id;
              });

              if (hotel) {
              } else if (property_id === '-1') {
                property_id = '-1';
              } else {
                property_id = pres.data[0].id;
              }
              this.setState({
                propertyList: pres.data,
                propertyId: property_id,
              });
            } else {
              const finalResult = [];
              pres.data.forEach((p) => {
                res.data.properties.forEach((r) => {
                  if (p.id === r) {
                    finalResult.push({
                      id: p.id,
                      name: p.name,
                      websiteLink: p.websiteLink,
                      rooms: p.rooms,
                      starRating: p.starRating,
                      type: p.type,
                      groupName: p.groupName,
                      isBmb: p.isBmb,
                      isAiva: p.isAiva
                    });
                  }
                });
              });

              const hotel = finalResult.find((elem) => {
                return elem.id === property_id;
              });

              if (hotel) {
              } else if (property_id === '-1') {
                property_id = '-1';
              } else {
                property_id = finalResult[0].id;
              }
              this.setState({
                propertyList: finalResult,
                propertyId: property_id,
              });
            }
            this.setState({ renderNav: true });
          })
          .catch((err) => console.error(err));
      })
      .catch((err) => console.error(err));
  }

  render() {
    const { containerClassnames } = this.props;    
    return (
      <Fragment>
        {this.state.role === 'View' ? <div id="app-container"
          className={`${window.innerWidth > 700? "" : "menu-mobile"}"menu-sub-hidden main-hidden sub-hidden"`}> {this.state.renderNav ? (
            <Fragment>
              <TopNav
                history={this.props.history}
                plist={this.state.propertyList}
                pid={this.state.propertyId}
                role={this.state.role}
                userData={this.state.userData}
              />
              <Sidebar role={this.state.role} pid={this.state.propertyId} />
            </Fragment>
          ) : (
            <Fragment>
              <nav className="navbar fixed-top">
                <a className="navbar-logo" href="/">
                  <img
                    src="/static/media/aiva_logo_large.f89ed2fe.jpg"
                    width={100}
                    alt="aiva"
                  />
                </a>
              </nav>
              <div className="sidebar">
                <div className="main-menu"></div>
              </div>
            </Fragment>
          )}
          <main>
            <div className="container-fluid">{this.props.children}</div>
          </main>
        </div> :
          <div id="app-container" className={window.innerWidth > 700? containerClassnames : "menu-mobile " + containerClassnames}>
            {this.state.renderNav ? (
              <Fragment>
                <TopNav
                  history={this.props.history}
                  plist={this.state.propertyList}
                  pid={this.state.propertyId}
                  role={this.state.role}
                  userData={this.state.userData}
                />
                <Sidebar role={this.state.role} pid={this.state.propertyId} />
              </Fragment>
            ) : (
              <Fragment>
                <nav className="navbar fixed-top">
                  <a className="navbar-logo" href="/">
                    <img
                      src="/static/media/aiva_logo_large.f89ed2fe.jpg"
                      width={100}
                      alt="aiva"
                    />
                  </a>
                </nav>
                <div className="sidebar">
                  <div className="main-menu"></div>
                </div>
              </Fragment>
            )}
            <main>
              <div className="container-fluid">{this.props.children}</div>
            </main>
          </div>
        }
      </Fragment>
    );
  }
}

const mapStateToProps = ({ menu, settings }) => {
  const { containerClassnames } = menu;
  const { locale, propertyId } = settings;
  return {
    containerClassnames,
    locale,
    propertyId,
  };
};
const mapActionToProps = { changeUser ,checkPin};

export default withRouter(
  connect(mapStateToProps, mapActionToProps)(AppLayout)
);
